import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ProfileSettingsPageSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
      <Box>
        <Box sx={{ mb: { xs: 3, md: 5 } }}>
          <Skeleton height={isMobile ? 36 : 48} width={isMobile ? 200 : 280} style={{ marginBottom: '8px' }} />
          <Skeleton height={isMobile ? 20 : 28} width={isMobile ? '100%' : 400} />
        </Box>

        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12}>
            <Card sx={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            }}>
              <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                <Box sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: { xs: 'center', sm: 'center' },
                  gap: { xs: 2, md: 3 },
                  textAlign: { xs: 'center', sm: 'left' }
                }}>
                  <Skeleton circle width={isMobile ? 100 : 120} height={isMobile ? 100 : 120} />
                  <Box sx={{ flex: 1 }}>
                    <Skeleton height={isMobile ? 24 : 32} width={isMobile ? 150 : 200} style={{ marginBottom: '8px' }} />
                    <Skeleton height={isMobile ? 16 : 20} width={isMobile ? 180 : 250} style={{ marginBottom: '4px' }} />
                    <Skeleton height={isMobile ? 14 : 16} width={isMobile ? 140 : 180} />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            }}>
              <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                  <Skeleton circle width={isMobile ? 40 : 48} height={isMobile ? 40 : 48} />
                  <Skeleton height={isMobile ? 24 : 32} width={isMobile ? 160 : 220} />
                </Box>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={6}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                  </Grid>
                </Grid>
                <Box mt={3}>
                  <Skeleton height={56} style={{ borderRadius: '12px' }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{
              borderRadius: '20px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
            }}>
              <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                  <Skeleton circle width={isMobile ? 40 : 48} height={isMobile ? 40 : 48} />
                  <Skeleton height={isMobile ? 24 : 32} width={isMobile ? 150 : 200} />
                </Box>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Skeleton height={56} style={{ borderRadius: '12px' }} />
                  </Grid>
                </Grid>
                <Box mt={3}>
                  <Skeleton height={56} style={{ borderRadius: '12px' }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </SkeletonTheme>
  );
};

export default ProfileSettingsPageSkeleton;
